import { Theme } from "interfaces/theme";
import styled, { css } from "styled-components";
import { fonts } from "styles";

export const Header = styled.header`
  width: 100%;
  padding-bottom: 16px;
  border-bottom: 1px solid #000;
  font-family: ${fonts.BentonSansWideBold};
  font-size: 14px;
  line-height: 22px;
  color: #000;
  text-transform: uppercase;
  margin-bottom: 40px;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    row-gap: 32px;
  }
`;

export const Column = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  color: #000;

  span {
    font-family: ${fonts.BentonSansRegular};
    font-size: 14px;
    line-height: 22px;
    display: block;
  }

  h6 {
    font-family: ${fonts.BentonSansWideBold};
    font-size: 15px;
    line-height: 22px;
  }
`;

interface IContainer {
  mode: Theme;
}
export const Container = styled.footer<IContainer>`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding-bottom: 180px;
  padding-left: 24px;
  padding-right: 24px;

  ${({ mode }) =>
    mode === "dark" &&
    css`
      ${Header} {
        color: #fff;
        border-color: #b4b4b4;
      }

      ${Column} {
        color: #fff;
      }
    `}
`;
